


export const refreshPageAfterAwake = () => {
  const TIMEOUT = 15*60*1000;
  let lastTime = performance.now();

  const resetTimer = () => {
    lastTime = performance.now(); // Reset the timer on any activity.
  };

  window.addEventListener('mousemove', resetTimer);
  window.addEventListener('keydown', resetTimer);

  setInterval(() => {
    const currentTime = performance.now();
    const delta = currentTime - lastTime;

    if (delta > TIMEOUT + 5000) {
      window.location.reload();
    }
  }, TIMEOUT);
};
